<template>
  <div id="app">
    <cheader></cheader>
    <carousel />

    <div class="content-wrapper">
      <div class="row" style="margin-left:0;margin-right:0">
        <div class="col-sm-3 content-left">
          <ul v-for="category in categoryList" v-bind:key="category.name">
            <li
              :class="(item.name == selectedProduct.name)?'active':''"
              v-for="item in category.products"
              v-bind:key="item.name"
              @click="changeProduct(item)"
            >
              <i class="iconfont" :class="item.icon" style="padding-right:20px"></i>
              {{item.name}}
            </li>
          </ul>
        </div>
        <div class="col-sm-9 content-right">
          <div
            class="version"
            v-for="version in selectedProduct.versions"
            v-bind:key="version.versionNo"
          >
            <div class="version-no">{{version.versionNo}}</div>
            <div class="version-date">{{version.date}}</div>
            <div class="version-log">
              <div
                class="version-log-item"
                v-for="changeLog in version.changeLogs"
                v-bind:key="changeLog.value"
              >{{changeLog.value}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <contact></contact>
    <cfooter></cfooter>
  </div>
</template>

<script>
import cheader from "../../components/cheader.vue";
import carousel from "../../components/carousel-version.vue";
import cfooter from "../../components/cfooter.vue";
import contact from "../../components/contact.vue";
import { categoryList, hotProductSearchKey } from "../../assets/js/resource.js";
export default {
  name: "app",
  data() {
    return {
      categoryList: categoryList,
      hotProductSearchKey: hotProductSearchKey,
      displayProductList: [],
      selectedProduct: {},
      searchName: ""
    };
  },
  components: { cheader, carousel, cfooter, contact },
  methods: {
    goProduct(id) {
      window.location.href = "/product.html?id=" + id;
    },
    productHover(index, hover) {
      var product = this.displayProductList[index];
      product.hover = hover;
      this.$set(this.displayProductList, index, product);
    },
    searchProduct() {
      var searchName = this.searchName;
      if (searchName) {
        this.filterProductByName(searchName);
      } else {
        this.populateALLProduct();
      }
    },
    changeProduct(product) {
      this.selectedProduct = product;
    },
    populateALLProduct() {
      var displayProductList = [];
      this.categoryList.forEach(function(category) {
        category.products.forEach(function(product) {
          displayProductList.push(product);
        });
      });
      this.displayProductList = displayProductList;
    },
    filterProductByCategory(selectedProduct) {
      var displayProductList = [];
      this.categoryList.forEach(function(category) {
        if (selectedProduct == category.name) {
          category.products.forEach(function(product) {
            displayProductList.push(product);
          });
        }
      });
      this.displayProductList = displayProductList;
    },
    filterProductByName(searchName) {
      var displayProductList = [];
      this.categoryList.forEach(function(category) {
        category.products.forEach(function(product) {
          if (product.name.indexOf(searchName) != -1)
            displayProductList.push(product);
        });
      });
      this.displayProductList = displayProductList;
    },
    filterHotProduct() {
      var displayProductList = [];
      this.categoryList.forEach(function(category) {
        category.products.forEach(function(product) {
          if (product.hot) {
            displayProductList.push(product);
          }
        });
      });
      this.displayProductList = displayProductList;
    }
  },
  created() {
    this.selectedProduct = this.categoryList[0].products[0]
  }
};
</script>

<style>
body {
  font-family: Arial, "microsoft yahei", Helvetica, sans-serif;
  background-color: #f3f3f3;
}
.statistic {
  width: 500px;
  height: 100px;
  text-align: center;
}
.content-wrapper {
  margin: -0 20px 20px 20px;
}
.content-left {
  background-color: #fff;
  margin: 20px 0 0 0;
}
.content-left ul {
  list-style: none;
}
.content-left ul li {
  font-size: 14px;
  letter-spacing: 0.4px;
  line-height: 60px;
  padding-left: 20px;
  cursor: pointer;
}
.content-left i {
  padding-right: 20px;
}
.content-left .active {
  background: rgba(249, 128, 32, 1);
  color: #fff;
}
.content-left ul li:hover {
  background: rgb(250, 167, 101);
  color: #fff;
}
.content-right {
  margin: 20px 0 0 0;
  padding: 0 50px;
}
.version {
  margin-bottom: 60px;
}
.version-no {
  color: #000;
  font-size: 20px;
  font-weight: bold;
}
.version-date {
  color: gray;
  font-size: 15px;
  margin-top: 5px;
}
.version-log {
  margin-top: 20px;
  color: #000;
  font-size: 12px;
}
.version-log-item {
  padding: 2px 0
}
</style>
